module.exports = __webpack_public_path__ + "static/media/product2.70f9a8bd.png";